import avatar from '../assets/images/kamila-camillo/kamila-camillo.jpg';
import audio from '../assets/sounds/kamila-camillo.ogg';

import kamila01 from '../assets/images/kamila-camillo/KamilaCamillo_01.jpg';
import kamila02 from '../assets/images/kamila-camillo/KamilaCamillo_02.jpg';
import kamila03 from '../assets/images/kamila-camillo/KamilaCamillo_03.jpg';
import kamila04 from '../assets/images/kamila-camillo/KamilaCamillo_04.jpg';
import kamila05 from '../assets/images/kamila-camillo/KamilaCamillo_05.jpg';
import kamila06 from '../assets/images/kamila-camillo/A_arte_de_brincar_2.jpg';
import kamila07 from '../assets/images/kamila-camillo/A_arte_de_brincar_3.jpg';
import kamila08 from '../assets/images/kamila-camillo/A_arte_de_brincar_4.jpg';
import kamila09 from '../assets/images/kamila-camillo/A_arte_de_brincar_5.jpg';
import kamila10 from '../assets/images/kamila-camillo/A_arte_do_novo.jpg';
import kamila11 from '../assets/images/kamila-camillo/A_arte_do_novo_2.jpg';
import kamila12 from '../assets/images/kamila-camillo/Arte_de_brincar.jpg';
import kamila13 from '../assets/images/kamila-camillo/Cotidiano_favelado_2.jpg';
import kamila14 from '../assets/images/kamila-camillo/Cotidiano_favelado_3.jpg';
import kamila15 from '../assets/images/kamila-camillo/Cotidiano_favelado_4.jpg';
import kamila16 from '../assets/images/kamila-camillo/Cotidiano_favelado1.jpg';







const kamilaData = {
    avatar,
    audio,
    kamila01,
    kamila02,
    kamila03,
    kamila04,
    kamila05,
    kamila06,
    kamila07,
    kamila08,
    kamila09,
    kamila10,
    kamila11,
    kamila12,
    kamila13,
    kamila14,
    kamila15,
    kamila16
    
}

export default kamilaData
